import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import { DropdownMenu } from '@rcg/ui-react';
import GuestMenu from '../GuestMenu';
import useStyles from './index.style';

const InlineMenu = (props) => {
  const {
    menuData,
    className,
    selectedOption = () => {},
    selectedGuests = () => {},
    disabled = false,
    disableCancelButton = false,
    selectedFlightType = null,
    ...others
  } = props;
  const classes = useStyles();
  return (
    <Grid {...others} className={classes.inlineMenuWrapper} item xs={12}>
      <Grid className={clsx(classes.inlineMenu, className)}>
        {menuData.map((menu) => {
          if (menu.type === 'dropDown') {
            return (
              <DropdownMenu
                key={menu.id}
                id={menu.id}
                onSelectedOption={selectedOption}
                // disable for change flight
                disabled={menu.disabled}
                menuItems={menu.items}
                setSelectedOption={selectedFlightType}
              />
            );
          }
          return (
            <>
              <GuestMenu
                disabled={disabled}
                disableCancelButton={disableCancelButton}
                key={menu.id}
                id={menu.id}
                onChoseDone={selectedGuests}
                labelMenu={menu.labelMenu}
                labelCancel={menu.labelCancel}
                labelDone={menu.labelDone}
                labelOnLapNote={menu.labelOnLapNote}
                unaccompaniedMinorError={menu.unaccompaniedMinorError}
                minAgeToTravelAlone={menu.minAgeToTravelAlone}
                minAgeToAccompanyMinors={menu.minAgeToAccompanyMinors}
                menuItems={menu.items}
              />
            </>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default InlineMenu;
